export default({
    app:"web",
    "baseUrls":{
        "inaia-eu":{
            "local":{
                "coreBaseUrl" : "https://core-staging.inaia.cloud/api/v1/",
                "bankBaseUrl" : "https://banking-staging.inaia.cloud/api/v1/",
                "goldDinarBaseUrl" : "https://golddinar-api-staging.inaia.cloud/api/v1/",
                "paymentsBaseUrl" : "https://payments-api-staging.inaia.cloud/api/v1/",
                "tradingBaseUrl" : "https://api-trading-staging.inaia.cloud/api/v1/"
            },
            "staging":{
                "coreBaseUrl" : "https://core-staging.inaia.cloud/api/v1/",
                "bankBaseUrl" : "https://banking-staging.inaia.cloud/api/v1/",
                "goldDinarBaseUrl" : "https://golddinar-api-staging.inaia.cloud/api/v1/",
                "paymentsBaseUrl" : "https://payments-api-staging.inaia.cloud/api/v1/",
                "tradingBaseUrl" : "https://api-trading-staging.inaia.cloud/api/v1/"
            },
            "production":{
                "coreBaseUrl" : "https://core.api.inaia.cloud/api/v1/",
                "bankBaseUrl" : "https://banking.api.inaia.cloud/api/v1/",
                "goldDinarBaseUrl" : "https://golddinar.api.inaia.cloud/api/v1/",
                "paymentsBaseUrl" : "https://payments.api.inaia.cloud/api/v1/",
                "tradingBaseUrl" : "https://trading.api.inaia.cloud/api/v1/"
            }
        },
        'green-gold':{
            "local":{
                "coreBaseUrl" : "https://core-staging.api.getgreengold.com/api/v1/",
                "bankBaseUrl" : "https://banking-staging.api.getgreengold.com/api/v1/",
                "goldDinarBaseUrl" : "https://gold-staging.api.getgreengold.com/api/v1/",
                "paymentsBaseUrl" : "https://payments-staging.api.getgreengold.com/api/v1/"
            },
            "staging":{
                "coreBaseUrl" : "https://core-staging.api.getgreengold.com/api/v1/",
                "bankBaseUrl" : "https://banking-staging.api.getgreengold.com/api/v1/",
                "goldDinarBaseUrl" : "https://gold-staging.api.getgreengold.com/api/v1/",
                "paymentsBaseUrl" : "https://payments-staging.api.getgreengold.com/api/v1/"
            },
            "production":{
                "coreBaseUrl" : "https://core.api.getgreengold.com/api/v1/",
                "bankBaseUrl" : "https://banking.api.getgreengold.com/api/v1/",
                "goldDinarBaseUrl" : "https://gold.api.getgreengold.com/api/v1/",
                "paymentsBaseUrl" : "https://payments.api.getgreengold.com/api/v1/"
            }
        },
        'inaia-uk':{
            "local":{
                "coreBaseUrl" : "https://inaia-uk-core-staging.inaia.cloud/api/v1/",
                "bankBaseUrl" : "https://inaia-uk-banking-staging.inaia.cloud/api/v1/",
                "goldDinarBaseUrl" : "https://inaia-uk-golddinar-staging.inaia.cloud/api/v1/",
                "paymentsBaseUrl" : "https://inaia-uk-payments-staging.inaia.cloud/api/v1/",
                "tradingBaseUrl" : "https://api-trading-staging.inaia.cloud/api/v1/"
            },
            "staging":{
                "coreBaseUrl" : "https://inaia-uk-core-staging.inaia.cloud/api/v1/",
                "bankBaseUrl" : "https://inaia-uk-banking-staging.inaia.cloud/api/v1/",
                "goldDinarBaseUrl" : "https://inaia-uk-golddinar-staging.inaia.cloud/api/v1/",
                "paymentsBaseUrl" : "https://inaia-uk-payments-staging.inaia.cloud/api/v1/",
                "tradingBaseUrl" : "https://api-trading-staging.inaia.cloud/api/v1/"
            },
            "production":{
                "coreBaseUrl" : "https://inaia-uk-core.inaia.cloud/api/v1/",
                "bankBaseUrl" : "https://inaia-uk-banking.inaia.cloud/api/v1/",
                "goldDinarBaseUrl" : "https://inaia-uk-golddinar.inaia.cloud/api/v1/",
                "paymentsBaseUrl" : "https://inaia-uk-payments.inaia.cloud/api/v1/",
                "tradingBaseUrl" : "https://api-trading-staging.inaia.cloud/api/v1/"
            }
        }
        
    },
    "staticLinks":{
        "inaia-eu":{
            privacyPolicy:"https://www.inaia.finance/de/datenschutzerklaerung/",
            imprint:"https://www.inaia.finance/de/impressum/",
        },
        "green-gold":{
            privacyPolicy:"https://getgreengold.com/de/datenschutzerklaerung/",
            imprint:"https://getgreengold.com/de/impressum/",
        },
        "inaia-uk":{
            privacyPolicy:"https://www.inaia.finance/de/datenschutzerklaerung/",
            imprint:"https://www.inaia.finance/de/impressum/",
        }
    }
})